import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment TaxFragment
 * @since 1.0.0
 */
export const TaxFragment = gql `
  fragment TaxFragment on Tax {
    id
    code
    title
    infos
    enabled
    rate
    createdAt
    updatedAt
    default
    code

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }

  ${LanguageFragment}
`;
